import HttpClient, { IResponseModel } from "./HttpClient";

import router, { getCurrentReturnUrl } from "../router";
import { routeFns } from "../router/routes";
import securityModule from "../security/SecurityModule";

export default class NetworkService {
  static async getMethod<TOutput>(url: string): Promise<IResponseModel<TOutput>> {
    // 0. Check if should be logged in
    const { idToken, sessionIsExpired } = securityModule;
    if (idToken && sessionIsExpired) {
      securityModule.signOut().then(() => {
        router.navigate(routeFns.login(getCurrentReturnUrl()), undefined, true);
      });
    }

    // 1. Make the request
    const client = new HttpClient();
    return await client.request<TOutput>({
      method: "GET",
      url,
    });
  }
}

